import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import {
  TypographyElement,
  Avatar,
  Icon,
  Icons,
  RateStars,
  Paper,
  Container,
  Button,
  ButtonVariation,
  ButtonSize,
  Row,
  Col
} from 'UI'
import Text from './text.json'
import { ProfileTypes } from 'constants/'
import { useEffect, useState } from 'react'
import { TrainerPrimaryPath } from 'navigation/Routes'
import { defaultCurrency } from 'store/currency'

const useStyle = createUseStyles(style)

export default ({
  ProfileType,
  Title,
  AuthorFirstName = '',
  AuthorLastName = '',
  AuthorPhoto,
  LevelId,
  Rating,
  ReviewersCount,
  scrollToPricing,
  goToTrainer,
  AuthorId,
  Price,
  addToCart,
  Image,
  MobileImageUrl,
  Id,
  Duration,
  ViewersCount,
  Slug,
  IsAccessible,
  AlternativePrice,
  PricePromo,
  AlternativePricePromo,
  IsFree,
  signup,
  setOnboardingFreeCourse,
  initialCurrency
}) => {
  const theme = useTheme()
  const [showBar, setShowBar] = useState(false)
  const handleScroll = _ => setShowBar(window.scrollY > 600)
  useEffect(() => {
    document.addEventListener('scroll', handleScroll)
    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const {
    icons,
    rateStarsClass,
    courseInfo,
    actions,
    paperClass,
    infos,
    row,
    priceContainer
  } = useStyle({ showBar })

  const accessTheFreeTrainingHandler = () => {
    setOnboardingFreeCourse(true)
    signup()
  }
  const usingEuro = initialCurrency === defaultCurrency
  const promoExist = PricePromo || AlternativePricePromo
  return (
    !IsAccessible
      ? (
        <Paper className={paperClass} noHover>
          <Container>
            <Row justify='between' className={row}>
              <Col grid={8}>
                <div className={courseInfo}>
                  <div>
                    <TypographyElement
                      variant='heading6'
                    >
                      {Title}
                    </TypographyElement>
                  </div>
                  <div className={infos}>
                    <Avatar
                      width={28}
                      height={28}
                      widthTablet={28}
                      heightTablet={28}
                      widthMobile={28}
                      heightMobile={28}
                      img={AuthorPhoto}
                      name={`${AuthorFirstName[0]}${AuthorLastName[0]}`}
                      handleClick={() => goToTrainer(`${TrainerPrimaryPath}/${AuthorId}`)}
                    />
                    <TypographyElement
                      variant='heading6'
                      color={theme.primary[0]}
                      spacing='0 16px 0 8px'
                      Component='a'
                      href={`${TrainerPrimaryPath}/${AuthorId}`}
                      handleClick={(e) => {
                        e.preventDefault()
                        goToTrainer(`${TrainerPrimaryPath}/${AuthorId}`)
                      }}
                      cursor='pointer'
                    >
                      {`${AuthorFirstName} ${AuthorLastName.toUpperCase()}`}
                    </TypographyElement>
                    <Icon iconName={Icons.dashboard} style={icons} />
                    <TypographyElement
                      variant='body1'
                      spacing='0 16px 0 8px'
                    >
                      {LevelId}
                    </TypographyElement>
                    {
                    !!Rating &&
                      <>
                        <Icon iconName={Icons.review} style={icons} />
                        <RateStars value={Rating} className={rateStarsClass} secondary />
                        <TypographyElement
                          variant='caption'
                          spacing='0 16px 0 2px'
                          margin='0 0 2px 0'
                        >
                          {`(${ReviewersCount})`}
                        </TypographyElement>
                      </>
                  }
                    {
                    ProfileType && ProfileType === ProfileTypes.Buyer && (
                      <>
                        <Icon iconName={Icons.shoppingCart} style={icons} />
                        <div className={priceContainer}>
                          <TypographyElement
                            spacing='0 0 0 8px'
                            variant='heading5'
                            color={promoExist ? theme.success[0] : null}
                          >
                            {usingEuro ? PricePromo || Price : AlternativePricePromo || AlternativePrice}
                            <TypographyElement
                              variant='heading5'
                              fontSize='1.1rem'
                              Component='span'
                              display='inline-block'
                              color={promoExist ? theme.success[0] : null}
                              spacing='0 0 0 4px'
                            >
                              {initialCurrency}
                            </TypographyElement>
                            {
                              promoExist
                                ? (
                                  <TypographyElement
                                    variant='heading6'
                                    display='inline-block'
                                    Component='span'
                                    textDecoration='line-through'
                                    spacing='0 0 0 8px'
                                  >
                                    {usingEuro ? Price : AlternativePrice}
                                    <TypographyElement
                                      variant='heading3'
                                      fontSize='1.1rem'
                                      Component='span'
                                      display='inline-block'
                                      textDecoration='line-through'
                                      spacing='0 0 0 4px'
                                    >
                                      {initialCurrency}
                                    </TypographyElement>
                                  </TypographyElement>
                                  )
                                : null
                            }
                          </TypographyElement>
                        </div>
                      </>
                    )
                  }
                  </div>
                </div>
              </Col>
              <Col grid={4} align='bot'>
                <div className={actions}>
                  {
                  !ProfileType || ProfileType === ProfileTypes.Default || ProfileType === ProfileTypes.FreeSubscriber
                    ? (
                        IsFree
                          ? (<Button
                              variation={ButtonVariation.confirmation}
                              size={ButtonSize.small}
                              label={Text.accessTheFreeTraining}
                              width='100%'
                              onHandleClick={accessTheFreeTrainingHandler}
                             />)
                          : (<Button
                              variation={ButtonVariation.primary}
                              size={ButtonSize.small}
                              label={Text.accessTheTraining}
                              width='100%'
                              onHandleClick={scrollToPricing}
                             />)
                      )
                    : ProfileType === ProfileTypes.BasicSubscriber || ProfileType === ProfileTypes.PremiumSubscriber
                      ? (
                        <Button
                          variation={ButtonVariation.confirmation}
                          size={ButtonSize.small}
                          label={Text.accessTheTraining}
                          width='100%'
                        />
                        )
                      : (
                        <Button
                          variation={ButtonVariation.primary}
                          size={ButtonSize.small}
                          label={Text.addToCart}
                          width='100%'
                          onHandleClick={() => addToCart({
                            Image,
                            MobileImageUrl,
                            Title,
                            Price,
                            Id,
                            Rating,
                            ReviewersCount,
                            Duration,
                            ViewersCount,
                            Slug,
                            AlternativePrice,
                            PromotionPrice: PricePromo,
                            AlternativePricePromo
                          })}
                        />
                        )
                }
                </div>
              </Col>
            </Row>
          </Container>
        </Paper>
        )
      : null
  )
}
